import { cn } from '@/lib/utils';

interface LogoProps {
  /**
   * Size variant for the logo
   */
  size?: 'sm' | 'md' | 'lg' | 'xl';
  /**
   * Additional CSS classes
   */
  className?: string;
}

const sizeClasses = {
  sm: 'h-6 w-auto',
  md: 'h-8 w-auto',
  lg: 'h-12 w-auto',
  xl: 'h-16 w-auto',
};

/**
 * Loomis Logo component with configurable size
 */
export default function Logo({ size = 'md', className }: LogoProps) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      {/* Logo Image */}
      <img
        src='/images/logo-loomis.svg'
        alt='Loomis Logo'
        className={cn(sizeClasses[size])}
        loading='eager'
      />
    </div>
  );
}

// Also export the props type for reuse
export type { LogoProps };
